const YES_OR_NO_OPTIONS = [
	{ key: 1, value: 'yes', label: 'Yes' },
	{ key: 0, value: 'no', label: 'No' },
];

export default YES_OR_NO_OPTIONS;
